/** @format */

import React from "react";

const BusinessTag = () => {
   return (
      <div>
         <span className="text-black flex gap-1 w-fit items-center text-[0.6rem] font-semibold tracking-widest bg-turquoise rounded-full px-1 h-5">
            <span className="text-[1.5rem] -mt-[2px]">•</span> Business
         </span>
      </div>
   );
};

export default BusinessTag;
